export default __webpack_public_path__ + "static/links-tera-02-dd508a1ed62e67bdcf723fb92fce688e.png";